import axios from "axios";
import { io } from "socket.io-client";

// const BASE_URL = `http://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}/api/`;
const BASE_URL = `/api/`;

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL || `http://${process.env.REACT_APP_API_HOST}:${process.env.REACT_APP_API_PORT}`;


export const socket = io(SOCKET_URL, {
  transports: ["websocket"],
  withCredentials: true,
});

const getUser = () => {
  const data = JSON.parse(localStorage.getItem("persist:root"))?.user;
  return data;
};
const user = getUser();
const currentUser = user && JSON.parse(user).currentUser;
const TOKEN = currentUser?.accessToken;

export const publicRequest = axios.create({
  baseURL: BASE_URL,
});
export const userRequest = axios.create({
  baseURL: BASE_URL,
  headers: { token: `Bearer ${TOKEN}` },
});
